module.exports = __webpack_public_path__ + "img/Dantam Makeover 03.b5a6fe6d.jpg";